import { render } from "./RetributionDetails.vue?vue&type=template&id=1e0cfc75"
import script from "./RetributionDetails.vue?vue&type=script&lang=js"
export * from "./RetributionDetails.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./RetributionDetails.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_6591d72d%2Fpackages%2Finsurer%2Fsrc%2Fcomponents%2Fplan_sales%2FRetributionDetails.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__